"use client";

export default function Desktop() {
    const cookies = [
        {
            name: "__Host-next-auth.csrf-token",
            purpose:
                "Varnostni piškotek, ki pomaga zaščititi prijavo pred ponarejenimi zahtevki (CSRF).",
            duration: "Do konca seje brskalnika.",
        },
        {
            name: "__Secure-next-auth.callback-url",
            purpose:
                "Shrani naslov spletne strani, na katero je uporabnik preusmerjen po prijavi.",
            duration: "Do konca seje brskalnika.",
        },
        {
            name: "__Secure-next-auth.session-token",
            purpose:
                "Shrani prijavni žeton, ki omogoča ohranjanje uporabnikove prijave brez ponovnega vnosa gesla ob vsakem obisku.",
            duration: "90 dni. Ob odjavi se piškotek izbriše.",
        },
    ];

    return (
        <div>
            <h1 className="font-medium text-[24px] leading-[27px] tracking-[0] mb-[25px]">
                Politika piškotkov
            </h1>

            <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                Nazadnje posodobljeno: 19. oktober 2026
            </p>

            <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                Spletna stran osmrtnica.com uporablja piškotke, ki so potrebni
                za prijavo uporabnikov in varno delovanje spletne strani.
                V nadaljevanju so opisani posamezni piškotki, njihov namen in
                trajanje.
            </p>

            <div>
                <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                    Kaj so piškotki?
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                    Piškotki so majhne besedilne datoteke, ki jih spletna
                    stran shrani v brskalnik uporabnika. Omogočajo izvajanje
                    posameznih funkcij spletne strani, med drugim varno
                    prijavo, preverjanje pristnosti in ohranjanje uporabnikove
                    prijavne seje.
                </p>
            </div>

            <div>
                <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                    Piškotki na osmrtnica.com
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                    Spodaj so navedeni piškotki, ki se uporabljajo za prijavo
                    in varno delovanje spletne strani.
                </p>

                {cookies.map((cookie) => (
                    <div key={cookie.name} className="mb-6">
                        <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                            {cookie.name}
                        </p>

                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Namen: {cookie.purpose}
                        </p>

                        <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                            Trajanje: {cookie.duration}
                        </p>
                    </div>
                ))}
            </div>

            <div>
                <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                    Soglasje
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                    Za nujno potrebne piškotke, ki omogočajo prijavo
                    uporabnika in varno delovanje spletne strani, soglasje
                    ni potrebno.
                </p>
            </div>

            <div>
                <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                    Upravljanje piškotkov
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-6">
                    Piškotke lahko izbrišete ali blokirate v nastavitvah
                    svojega spletnega brskalnika. Če izbrišete prijavne
                    piškotke, boste morda odjavljeni in se boste morali
                    ponovno prijaviti. Če blokirate piškotke, prijava
                    morda ne bo delovala pravilno.
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0] mb-2">
                    Navodila za upravljanje in brisanje piškotkov:
                </p>

                <ul className="list-disc marker:text-gray-400 pl-5 font-light mb-6">
                    <li>
                        Chrome:{" "}
                        <a
                            className="underline underline-offset-[4px]"
                            href="https://support.google.com/chrome/answer/95647?hl=sl"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Brisanje, omogočanje in upravljanje piškotkov
                        </a>
                    </li>

                    <li>
                        Safari (Mac):{" "}
                        <a
                            className="underline underline-offset-[4px]"
                            href="https://support.apple.com/sl-si/guide/safari/sfri11471/mac"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Upravljanje piškotkov
                        </a>
                    </li>

                    <li>
                        Firefox:{" "}
                        <a
                            className="underline underline-offset-[4px]"
                            href="https://support.mozilla.org/sl/kb/izbrisite-piskotke-podatke-strani"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Brisanje piškotkov in podatkov strani
                        </a>
                    </li>
                </ul>
            </div>

            <div>
                <p className="font-medium text-[16px] leading-[27px] tracking-[0] mb-[5px]">
                    Kontakt
                </p>

                <p className="font-light text-[16px] leading-[27px] tracking-[0]">
                    Za vprašanja glede piškotkov nam pišite na{" "}
                    <a
                        className="underline underline-offset-[4px]"
                        href="mailto:info@osmrtnica.com"
                    >
                        info@osmrtnica.com
                    </a>
                    .
                </p>
            </div>
        </div>
    );
}
